import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import AppShell from "../components/feature/AppShell";

import DashboardPage from "../pages/dashboard/page";
import RandevularPage from "../pages/appointments/page";
import OnlineRequestsPage from "../pages/online_requests/page";
import OnlineRandevuPage from "../pages/online_randevu/page";
import MusterilerPage from "../pages/customers/page";
import CustomerDetailPage from "../pages/customers/detail/page";
import GuvenlikPage from "../pages/security/page";
import HizmetlerPage from "../pages/services/page";
import PaketlerPage from "../pages/packages/page";
import FinansPage from "../pages/cash/page";
import NakitKasaPage from "../pages/cash/nakit/page";
import BankaHesabiPage from "../pages/cash/banka/page";
import GiderlerPage from "../pages/expenses/page";
import PersonelPage from "../pages/staff/page";
import StokPage from "../pages/stock/page";
import KampanyalarPage from "../pages/campaigns/page";
import WhatsAppSMSPage from "../pages/whatsapp_sms/page";
import RaporlarPage from "../pages/reports/page";
import AbonelikPage from "../pages/subscription/page";
import AyarlarPage from "../pages/settings/page";
import AnketlerPage from "../pages/surveys/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <AppShell><DashboardPage /></AppShell>,
  },
  {
    path: "/randevular",
    element: <AppShell><RandevularPage /></AppShell>,
  },
  {
    path: "/online-randevu",
    element: <AppShell><OnlineRequestsPage /></AppShell>,
  },
  {
    path: "/musteriler",
    element: <AppShell><MusterilerPage /></AppShell>,
  },
  {
    path: "/musteri/:id",
    element: <AppShell><CustomerDetailPage /></AppShell>,
  },
  {
    path: "/güvenlik",
    element: <AppShell><GuvenlikPage /></AppShell>,
  },
  {
    path: "/hizmetler",
    element: <AppShell><HizmetlerPage /></AppShell>,
  },
  {
    path: "/paketler",
    element: <AppShell><PaketlerPage /></AppShell>,
  },
  {
    path: "/kasa",
    element: <AppShell><FinansPage /></AppShell>,
  },
  {
    path: "/finans/nakit",
    element: <AppShell><NakitKasaPage /></AppShell>,
  },
  {
    path: "/finans/banka",
    element: <AppShell><BankaHesabiPage /></AppShell>,
  },
  {
    path: "/giderler",
    element: <AppShell><GiderlerPage /></AppShell>,
  },
  {
    path: "/personel",
    element: <AppShell><PersonelPage /></AppShell>,
  },
  {
    path: "/stok",
    element: <AppShell><StokPage /></AppShell>,
  },
  {
    path: "/kampanyalar",
    element: <AppShell><KampanyalarPage /></AppShell>,
  },
  {
    path: "/whatsapp-sms",
    element: <AppShell><WhatsAppSMSPage /></AppShell>,
  },
  {
    path: "/raporlar",
    element: <AppShell><RaporlarPage /></AppShell>,
  },
  {
    path: "/anketler",
    element: <AppShell><AnketlerPage /></AppShell>,
  },
  {
    path: "/abonelik",
    element: <AppShell><AbonelikPage /></AppShell>,
  },
  {
    path: "/ayarlar",
    element: <AppShell><AyarlarPage /></AppShell>,
  },
  {
    path: "/online-randevu-sayfa",
    element: <OnlineRandevuPage />,
  },
  {
    path: "*",
    element: <AppShell><NotFound /></AppShell>,
  },
];

export default routes;